import script from "./orionNoSavedVehicles.vue?vue&type=script&setup=true&lang=ts"
export * from "./orionNoSavedVehicles.vue?vue&type=script&setup=true&lang=ts"

import "./orionNoSavedVehicles.vue?vue&type=style&index=0&id=a4e07816&scoped=true&lang=scss"

import exportComponent from "C:\\agent\\_work\\1678\\s\\VCLWSAA\\source\\VCLWSAA.Presentation.Web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a4e07816"]])

export default __exports__